import { api, apiUrl } from "./../../api/index";

const url = `${apiUrl}/bonus`;

export const fetchBonus = async () => {
  return api(`${url}`, {
    method: "GET",
  }).then((res) => res.json());
};
